import {
  createBuffer as createBufferFn,
  createResizableBuffer as createResizableBufferFn,
  extendResizableBuffer as extendResizableBufferFn,
} from "./dotnetExports/buffers";

let currentBufferId = 1;
export const RESIZABLE_BUFFER_SIZE = 16384;

export function setBuffer(data: ArrayBuffer): number {
  const buffer = new Uint8Array(data);

  // const id = this.applyBitmapIndexFn(buffer.length);
  const id = currentBufferId++;
  const ptr = createBufferFn(id, buffer.length);
  Module.HEAPU8.set(buffer, ptr);

  return id;
}

export function createFixedBuffer(size: number) {
  const id = currentBufferId++;
  const ptr = createBufferFn(id, size);
  const view = new DataView(Module.HEAPU8.buffer, ptr, size);
  return { id, view };
}

export function createResizableBuffer() {
  const id = currentBufferId++;
  const ptr = createResizableBufferFn(id);
  const view = new DataView(Module.HEAPU8.buffer, ptr, RESIZABLE_BUFFER_SIZE);
  return { id, view };
}

export function extendResizableBuffer(id: number) {
  const ptr = extendResizableBufferFn(id);
  return new DataView(Module.HEAPU8.buffer, ptr, RESIZABLE_BUFFER_SIZE);
}
